import { useContext, useEffect } from 'react';
import { SmartContext } from '../../../../library/Core/SmartContext';
import { isEmpty } from '../../../../library/Core/SmartFunctions';
import PieChartComponent from '../../../../library/SimpleControls/PieChartControl';
import useRecruiterDashboard from './useRecruiterDashboard';

const RecruiterIndustryRoles = () => {
    const { state } = useContext(SmartContext);
    const { getRecruiterIndustryRolesData } = useRecruiterDashboard();

    useEffect(() => {
        getRecruiterIndustryRolesData();
    }, []);

    if (isEmpty(state.data?.reportData?.recruiterIndustryRoles))
    return (
        <>
            <div>No Data Available</div>
        </>
    );

    return (
        <>
            <PieChartComponent data={state.data.reportData.recruiterIndustryRoles} />
        </>
    );
};

export default RecruiterIndustryRoles;
